import React from "react";
import { message, Form, Tag } from "antd";
import styled from "styled-components";
import { DeleteOutlined } from "@ant-design/icons";

// import colors from "constants/palette";
import Button from "components/buttons/Button";
import Input from "components/inputs/Input";
const tag = "#";
export default function Tags({ form, initialValue }) {
  const [inputValue, setInputValue] = React.useState("");
  const [list, setList] = React.useState(
    initialValue?.length ? initialValue.split(tag) : []
  );
  const handleInput = ({ target }) => {
    setInputValue(target.value);
  };
  const handleAdd = () => {
    if (!inputValue) {
      message.error("لطفا متن تگ را تایپ کنید.");
      return false;
    }
    setInputValue("");
    setList((e) => [...e, inputValue]);
    return false;
  };

  const handleDelete = (event, key) => {
    setList((e) => {
      let newList = [...e];
      newList.splice(key, 1);
      return newList;
    });
    event.preventDefault();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      handleAdd();
      event.preventDefault();
    }
  };

  React.useEffect(() => {
    form.setFieldsValue({ tags: list.join(tag) });
  }, [list]);

  return (
    <Form.Item name="tags">
      <Container>
        <h3>تگ ها :</h3>
        <InputContainer>
          <Input
            value={inputValue}
            onChange={handleInput}
            onKeyDown={handleKeyDown}
          />
          <Button type="button" size="middle" onClick={handleAdd}>
            اضافه کردن
          </Button>
        </InputContainer>
        {list.map((item, key) => (
          <Tag key={key} closable onClose={(e) => handleDelete(e, key)}>
            {item}
          </Tag>
        ))}
      </Container>
    </Form.Item>
  );
}

const Container = styled.div`
  margin-top: 3rem;
  text-align: start;

  & ol {
    list-style-position: inside;
    margin-top: 1rem;
  }

  & li {
    padding: 7px;
    border-radius: 4px;
    margin-bottom: 8px;
    border: 1px dashed #d5d5d5;
    overflow: auto;

    & .edit {
      margin-right: auto;
      float: left;
      font-size: 18px;
      cursor: pointer;
      padding: 2px 8px;
    }

    & .delete {
      color: red;
      margin-right: auto;
      float: left;
      font-size: 18px;
      cursor: pointer;
      padding: 2px 8px;
    }
  }
`;
const InputContainer = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 8px;
  aa input,
  button {
    height: 38px;
    display: flex;
    align-items: center;
  }
  & > div {
    margin-top: 0;
    margin-left: 9px;
    width: 88%;
  }
`;
